import React from "react";
import { motion } from "framer-motion";
import { useInView } from "react-intersection-observer";
import { Text } from "@sitecore-jss/sitecore-jss-react";

import MediaFocal from "../../MediaFocal";

import "./timeline-introimage.scss";

const TimelineIntroImage = ({media, sectionIndex, subHeadline, isWide, xTransform}) => {
    const [image, inView] = useInView({threshold: 0.2});

    return (
        <motion.div 
            ref={image} 
            animate={{ opacity: inView ? 1 : 0, x: inView ? 0 : -20 }}
            transition={{ duration: 0.8 }} 
            className={`timeline-introimage ${isWide ? 'timeline-introimage--wide' : ''} ${sectionIndex % 2 === 0 ? 'timeline-introimage--offset' : ''}`}>
            
            <div className="timeline-introimage__inner">
                {subHeadline && 
                <motion.div className="timeline-introimage__headline" style={{x: xTransform}}><Text tag="h2" field={subHeadline}/></motion.div>}
                {media?.fields && <MediaFocal fields={media.fields} />}
            </div>
            
        </motion.div>
    );
};

export default TimelineIntroImage;